/**
 * Created by kb on 2017/11/17.
 */
import  {menuPage} from  '@/commonJs/commonconf'

/**
 * 按钮权限赋值
 * @param btnAuthor 仅供权限检查使用
 */
Array.prototype.authorFilter = function (btnAuthor) {
  for (let key in btnAuthor) {
    let btn = btnAuthor[key];
    let mapFilter = this.filter(values => {
      return values.menuType == key;
    });
    if (mapFilter.length > 0) {
      btn.isShow = true;
      btn.reqUrl = mapFilter[0].requestUrl;
      btn.menuUrl = mapFilter[0].menuUrl;
    } else {
      btn.isShow = menuPage.loginUser.adminuser === 1;
    }
  }
}

/**
 * 按钮权限赋值
 * @param btnAuthor  仅供权限检查使用
 */
Array.prototype.has_permission = function (btnName) {
  let mapFilter = this.filter(values => {
    return values.menuType == btnName;
  });
  return mapFilter.length > 0 ;
}


/**
 * 拷贝一个新的ArryJson数组
 * @param fileds  将fileds（只拷贝部分属性，并且属性重新命名）
 * @returns {Array}
 */
Array.prototype.copyArryJson = function (fileds = {}) {
  let arryJson = [];
  let keys = [];
  for (let filedKey in fileds) {
    keys.push(filedKey);
  }
  if (keys == 0) {
    for (let json of this) {
      let jsonNew = {};
      for (let key in json) {
        jsonNew[key] = json[key]
      }
      arryJson.push(jsonNew);
    }
  } else {
    for (let json of this) {
      let jsonNew = {};
      for (let key in json) {
        if (keys.indexOf(key) >= 0)
          jsonNew[fileds[key]] = json[key]
      }
      arryJson.push(jsonNew);
    }
  }
  return arryJson;
}

/**
 * 从菜单Tree数据中查找当前界面对应的MenuCode 仅供权限检查使用
 * @param path
 * @param menuPage
 */
Array.prototype.findMenuCodeByPath = function (path,menuPage) {
  for (let i = 0; i < this.length; i++) {
    if(menuPage.pageCode.notBlank()) {
      break;
    }
    let menu = this[i];
    if (menu.menuUrl && $.trim(menu.menuUrl.toLowerCase()) == $.trim(path.toLowerCase())) {
      menuPage.pageCode = menu.menuCode;
      menuPage.pageLevel = parseInt(menu.menuLevel);
      menuPage.pid = menu.parentId;
      menuPage.reqUrl=menu.requestUrl;
    } else {
      menu.children.findMenuCodeByPath(path,menuPage);
    }
  }
}


/**
 * 从菜单Tree数据中检查当前对象的menuBtn对象的MenuUrl 是否一致  仅供权限检查使用
 * @param path
 * @param menuPage
 */
Array.prototype.checkMenuUrl = function (menuBtn) {
  for (let i = 0; i < this.length; i++) {
    if(menuBtn.isShow) {
      break;
    }
    let menu = this[i];
    if (menu.menuUrl && $.trim(menu.menuUrl.toLowerCase()) == $.trim(menuBtn.menuUrl.toLowerCase())) {
      menuBtn.isShow = true;
    } else {
      menu.children.checkMenuUrl(menuBtn);
    }
  }
}

/**
 * Arry数组对象赋值有相同Key的对象值
 * @param newArryJson
 */
Array.prototype.attrMapping = function (newArryJson) {
  if(newArryJson==undefined || newArryJson.length==0) {
    return;
  }
  let newJson = newArryJson[0];
  for (let i = 0; i < this.length; i++) {
    let curJson = this[i];
    for (let key in curJson) {
      if (newJson.hasOwnProperty(key)) {
        this[i][key] = newArryJson[i][key];
      }
    }
  }
}

/**
 * 数组合计
 * @param sumKey （可选项：数组数据项为对象时 合计对象键为sumKey的值）
 * @returns {number}
 */
Array.prototype.sum = function (sumKey) {
  let sum = 0;
  try {
    this.forEach((item, index) => {
      if (sumKey) {
        sum += parseFloat(item[sumKey])
      } else {
        sum += parseFloat(item)
      }
    });
  } catch (e) {
    sum = 0;
  }
  return sum;
}


/**
 * 判断原生数据对象是否有该方法
 */
if (!Array.prototype.includes) {
  Object.defineProperty(Array.prototype, 'includes', {
    value: function(searchElement, fromIndex) {

      // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If len is 0, return false.
      if (len === 0) {
        return false;
      }

      // 4. Let n be ? ToInteger(fromIndex).
      //    (If fromIndex is undefined, this step produces the value 0.)
      var n = fromIndex | 0;

      // 5. If n ≥ 0, then
      //  a. Let k be n.
      // 6. Else n < 0,
      //  a. Let k be len + n.
      //  b. If k < 0, let k be 0.
      var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

      // 7. Repeat, while k < len
      while (k < len) {
        // a. Let elementK be the result of ? Get(O, ! ToString(k)).
        // b. If SameValueZero(searchElement, elementK) is true, return true.
        // c. Increase k by 1.
        // NOTE: === provides the correct "SameValueZero" comparison needed here.
        if (o[k] === searchElement) {
          return true;
        }
        k++;
      }

      // 8. Return false
      return false;
    }
  });
}





// WEBPACK FOOTER //
// ./src/commonJs/objExtend/Array_E.js